export default __webpack_public_path__ + "static/media/ds-solucao-problemas.9bc7f165.png";